import { FormEvent } from 'react'
import { HttpVerb } from '../../../types/api-types'
import { WellsAPIClientFieldsView } from '../../../types/form-types'
import { useSaveWellData } from '../../hooks/use-api'
import useEditForm from '../../hooks/use-edit-form'
import {
  Button,
  ButtonsContainer,
  FormField,
  Heading,
  InlineNotification,
  Modal,
  ReadOnlyField,
  TextInput,
} from '@msaf/core-react'

export function NewAPIClientModal({ onRequestClose }: { onRequestClose: VoidFunction }) {
  const saveMutation = useSaveWellData(`users/api-client/`, HttpVerb.POST)
  const { fields, isLoading, resetUseEditFormState, handleSave, validationErrors, isSaved } =
    useEditForm<WellsAPIClientFieldsView>({
      saveMutationResult: saveMutation,
      setIsDirty: () => {} /** Form dirty check is not required here */,
    })

  const handleClose = () => {
    resetUseEditFormState()
    onRequestClose()
  }

  function saveForm(e: FormEvent) {
    e.preventDefault()

    const getInputValue = (selector: string) => {
      const formEl = e?.currentTarget
      const value = (formEl?.querySelector(selector) as HTMLInputElement)?.value
      return value ?? null
    }

    // Update the fields with the values of the inputs
    if (fields) {
      Object.assign(fields, {
        name: getInputValue('input#name'),
      })
    }

    handleSave()
  }

  return (
    <Modal isOpen={true} onRequestClose={handleClose} contentLabel={''}>
      <Heading level={1}>New API client</Heading>
      <form onSubmit={saveForm}>
        {validationErrors.error && (
          <InlineNotification messageType='error' isDismissable={false}>
            {validationErrors.error}
          </InlineNotification>
        )}
        <FormField label='Name' labelId='name' validationMessages={validationErrors?.name} isRequired>
          <TextInput isDisabled={isSaved} autoFocus={true} id='name' value={fields.name ?? ''} setValue={() => {}} />
        </FormField>

        {saveMutation.data && (
          <>
            <InlineNotification messageType='info' isDismissable={false}>
              The client ID and secret have been generated. Please make a note of secret value in particular now as it
              will not be shown again. If you loose your secret you will need to recreate it.
            </InlineNotification>
            <FormField label='Client ID' labelId='clientId'>
              <ReadOnlyField labelledBy='clientId' value={saveMutation.data.clientId} />
            </FormField>
            <FormField label='Client Secret' labelId='clientSecret'>
              <ReadOnlyField labelledBy='secret' value={saveMutation.data.secret} />
            </FormField>
          </>
        )}
        <ButtonsContainer containerStyle='right'>
          {isSaved && <Button label='Close' onClick={handleClose} buttonStyle='primary' isDisabled={isLoading} />}
          {!isSaved && (
            <>
              <Button label='Submit' type='submit' buttonStyle='primary' isDisabled={isLoading} />
              <Button label='Cancel' buttonStyle='text-action' onClick={handleClose} isDisabled={isLoading} />
            </>
          )}
        </ButtonsContainer>
      </form>
    </Modal>
  )
}
